"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRetailLocations = exports.mockSerializedRetailLocations = void 0;
const RetailLocation_1 = require("../../../models/RetailLocation");
const delivery_1 = require("../../../types/delivery");
exports.mockSerializedRetailLocations = [
    {
        title: "Mock Darlinghurst",
        id: "702",
        slug: "darlinghurst",
        address: {
            fullAddress: "Shop 1, 107-111 Oxford St DARLINGHURST NSW 2010  Australia ",
            country: "Australia",
            lat: -33.8791882,
            lng: 151.2149201
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 3600,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Daylight Time"
        },
        region: null,
        retailLocationId: "2006",
        phoneNumber: "(02) 9358 1900",
        email: "2006@zambrero.com.au",
        openingHours: [
            { close: { day: 0, time: "2200" }, open: { day: 0, time: "1100" } },
            { close: { day: 1, time: "2200" }, open: { day: 1, time: "1000" } },
            { close: { day: 2, time: "2200" }, open: { day: 2, time: "1000" } },
            { close: { day: 5, time: "0000" }, open: { day: 4, time: "1000" } },
            { close: { day: 6, time: "0200" }, open: { day: 5, time: "1000" } },
            { close: { day: 0, time: "0200" }, open: { day: 6, time: "1100" } }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "165 865 378",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: 20,
        maximumOrderValue: 150,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Civic",
        id: "693",
        slug: "civic",
        address: {
            fullAddress: "Corner East Row & Alinga Street CIVIC ACT 2612 Australia",
            country: "Australia",
            lat: -35.2786944,
            lng: 149.1303321
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1002",
        phoneNumber: "(02) 6262 6820",
        email: "1002@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 1,
                    time: "2000"
                },
                open: {
                    day: 1,
                    time: "1145"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2000"
                },
                open: {
                    day: 2,
                    time: "1145"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2000"
                },
                open: {
                    day: 3,
                    time: "1145"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2200"
                },
                open: {
                    day: 4,
                    time: "1145"
                }
            },
            {
                close: {
                    day: 6,
                    time: "0000"
                },
                open: {
                    day: 5,
                    time: "1145"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2200"
                },
                open: {
                    day: 6,
                    time: "1600"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "38130628689",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 5,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Belconnen",
        id: "669",
        slug: "belconnen",
        address: {
            fullAddress: "Shop 5, 102 Emu Bank BELCONNEN ACT 2617  Australia ",
            country: "Australia",
            lat: -35.2369836,
            lng: 149.0713962
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1004",
        phoneNumber: "(02) 6253 4636",
        email: "1004@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "2200"
                },
                open: {
                    day: 0,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2200"
                },
                open: {
                    day: 1,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2200"
                },
                open: {
                    day: 2,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2200"
                },
                open: {
                    day: 3,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2200"
                },
                open: {
                    day: 4,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2200"
                },
                open: {
                    day: 5,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2200"
                },
                open: {
                    day: 6,
                    time: "1100"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "29 603 704 678",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Erindale",
        id: "711",
        slug: "erindale",
        address: {
            fullAddress: "Shop 28 Erindale ShopCtr WANNIASSA ACT 2903  Australia ",
            country: "Australia",
            lat: -35.4040299,
            lng: 149.0987826
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1007",
        phoneNumber: "(02) 6231 8145",
        email: "1007@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "2000"
                },
                open: {
                    day: 0,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2030"
                },
                open: {
                    day: 1,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2030"
                },
                open: {
                    day: 2,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2030"
                },
                open: {
                    day: 3,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2100"
                },
                open: {
                    day: 4,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2100"
                },
                open: {
                    day: 5,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2000"
                },
                open: {
                    day: 6,
                    time: "1100"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "24 140 621 905",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Jamison",
        id: "733",
        slug: "jamison",
        address: {
            fullAddress: "Shop B04, Jamison ShopCtr Bowman St MACQUARIE ACT 2614  Australia ",
            country: "Australia",
            lat: -35.2531784,
            lng: 149.0707039
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1010",
        phoneNumber: "(02) 6251 3426",
        email: "1010@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "2100"
                },
                open: {
                    day: 0,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2100"
                },
                open: {
                    day: 1,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2100"
                },
                open: {
                    day: 2,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2100"
                },
                open: {
                    day: 3,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2100"
                },
                open: {
                    day: 4,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2100"
                },
                open: {
                    day: 5,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2100"
                },
                open: {
                    day: 6,
                    time: "1030"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "71 616 074 750",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Gungahlin",
        id: "1132",
        slug: "gungahlin",
        address: {
            fullAddress: "Shop 23, Marketplace Gungahlin old Hibberson St GUNGAHLIN OLD ACT 2912  Australia ",
            country: "Australia",
            lat: -35.1854749,
            lng: 149.1337264
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1014",
        phoneNumber: "(02) 6154 4763",
        email: "1014@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "2100"
                },
                open: {
                    day: 0,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2100"
                },
                open: {
                    day: 1,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2100"
                },
                open: {
                    day: 2,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2100"
                },
                open: {
                    day: 3,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2100"
                },
                open: {
                    day: 4,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2100"
                },
                open: {
                    day: 5,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2100"
                },
                open: {
                    day: 6,
                    time: "1030"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "47 619 296 098",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Weston Creek",
        id: "832",
        slug: "weston-creek",
        address: {
            fullAddress: "12/14-16 Brierly St WESTON CREEK ACT 2611  Australia ",
            country: "Australia",
            lat: -35.3420891,
            lng: 149.0524454
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1017",
        phoneNumber: "(02) 6287 4923",
        email: "1017@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "2100"
                },
                open: {
                    day: 0,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2100"
                },
                open: {
                    day: 1,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2100"
                },
                open: {
                    day: 2,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2100"
                },
                open: {
                    day: 3,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2100"
                },
                open: {
                    day: 4,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2100"
                },
                open: {
                    day: 5,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2100"
                },
                open: {
                    day: 6,
                    time: "1030"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "609 787 359",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Woden",
        id: "834",
        slug: "woden",
        address: {
            fullAddress: "L72A Food Court Westfield WODEN ACT 2606  Australia ",
            country: "Australia",
            lat: -35.3464725,
            lng: 149.0867019
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1018",
        phoneNumber: "(02) 6282 8772",
        email: "1018@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "1630"
                },
                open: {
                    day: 0,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 1,
                    time: "1700"
                },
                open: {
                    day: 1,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 2,
                    time: "1700"
                },
                open: {
                    day: 2,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 3,
                    time: "1700"
                },
                open: {
                    day: 3,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 4,
                    time: "1700"
                },
                open: {
                    day: 4,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2100"
                },
                open: {
                    day: 5,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 6,
                    time: "1700"
                },
                open: {
                    day: 6,
                    time: "1000"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "20 621 774 507",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Manuka",
        id: "750",
        slug: "manuka",
        address: {
            fullAddress: "17 Franklin St MANUKA ACT 2603  Australia ",
            country: "Australia",
            lat: -35.3198157,
            lng: 149.1330665
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1025",
        phoneNumber: "0413 085 616",
        email: "1025@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "2100"
                },
                open: {
                    day: 0,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2100"
                },
                open: {
                    day: 1,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2100"
                },
                open: {
                    day: 2,
                    time: "1100"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2130"
                },
                open: {
                    day: 3,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2130"
                },
                open: {
                    day: 4,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2130"
                },
                open: {
                    day: 5,
                    time: "1000"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2100"
                },
                open: {
                    day: 6,
                    time: "1100"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "57 604 770 327",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    },
    {
        title: "Mock Tuggeranong",
        id: "816",
        slug: "tuggeranong",
        address: {
            fullAddress: "Tuggeranong Hyperdome ShopCtr TUGGERANONG ACT 2900  Australia ",
            country: "Australia",
            lat: -35.4160303,
            lng: 149.0677049
        },
        googlePlaces: null,
        locationFeatures: null,
        timezone: {
            dstOffset: 0,
            rawOffset: 36000,
            status: "OK",
            timeZoneId: "Australia/Sydney",
            timeZoneName: "Australian Eastern Standard Time"
        },
        region: null,
        retailLocationId: "1099",
        phoneNumber: "(02) 6293 2096",
        email: "1099@zambrero.com.au",
        openingHours: [
            {
                close: {
                    day: 0,
                    time: "1930"
                },
                open: {
                    day: 0,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 1,
                    time: "2100"
                },
                open: {
                    day: 1,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 2,
                    time: "2100"
                },
                open: {
                    day: 2,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 3,
                    time: "2100"
                },
                open: {
                    day: 3,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 4,
                    time: "2100"
                },
                open: {
                    day: 4,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 5,
                    time: "2100"
                },
                open: {
                    day: 5,
                    time: "1030"
                }
            },
            {
                close: {
                    day: 6,
                    time: "2100"
                },
                open: {
                    day: 6,
                    time: "1030"
                }
            }
        ],
        orderingStatus: {
            config: {
                availableForPickup: true,
                availableForDelivery: true
            },
            location: {
                availableForPickup: true,
                availableForDelivery: true,
                pickupReason: "",
                deliveryReason: ""
            }
        },
        registrationNumber: "68 606 897 901",
        paymentGatewayId: "5c8f40f94aba3c6d7f3e3245",
        stripePaymentGatewayId: "",
        deliveryType: delivery_1.TDeliveryOptions.Self,
        maxDeliveryDistance: 7,
        deliveryCost: 4.99,
        serviceFee: 5,
        minimumDeliveryAmount: null,
        maximumOrderValue: null,
        orderingTimes: {
            averagePickupTime: 15,
            averageDeliveryTime: 40
        },
        pricingCodes: {
            pickup: "P1",
            delivery: "D1"
        }
    }
];
exports.mockRetailLocations = exports.mockSerializedRetailLocations.map((retailLocation) => RetailLocation_1.RetailLocation.unserialize(retailLocation));
//# sourceMappingURL=mockRetailLocations.js.map